import { numberFormat } from "src/helpers/numberFormat";
import { AnnualGridSupplyFormValues } from "src/pages/AnnualGridSupply";
import * as yup from "yup";

export const annualGridSupplyFormSchema: yup.ObjectSchema<AnnualGridSupplyFormValues> =
  yup.object({
    personsInHousehold: yup.number().min(1).max(5).required(),

    yearlyGridSupplyKwh: yup
      .string()
      .transform((value) => {
        const updatedValue = numberFormat(value);

        if (updatedValue.slice(-1) === "." || updatedValue.slice(-1) === ",")
          return undefined;

        const updatedValueWithoutComma = updatedValue.replace(",", "");
        const updatedValueNum = +updatedValueWithoutComma;

        if (isNaN(updatedValueNum)) return undefined;

        if (updatedValueNum < 100 || updatedValueNum > 100000) return undefined;
        return value;
      })
      .required("page.annualGridSupply.formError.invalid"),
  });
